import { Alert, MenuItem, TextField } from '@mui/material';
import type { useGgaFreeSpinBetLevels } from '../../queries/casino';
import RetryAlert from './RetryAlert';

type Props = {
  betLevels: ReturnType<typeof useGgaFreeSpinBetLevels>;
  value: unknown;
  onChange: (value: number) => void;
  onBlur: () => void;
  disabled: boolean;
  error?: string;
};

const GgaBetLevelField = ({ betLevels, value, onChange, onBlur, disabled, error }: Props) => (
  <>
    <TextField
      select
      label='Bet Level'
      required
      value={typeof value === 'number' || typeof value === 'string' ? value : ''}
      onChange={(event) => onChange(Number(event.target.value))}
      onBlur={onBlur}
      disabled={disabled || betLevels.isFetching || betLevels.isError || !betLevels.data?.length}
      error={!!error}
      helperText={error}
    >
      {(betLevels.data ?? []).map((level) => (
        <MenuItem key={level.value} value={level.value}>
          {level.label}
        </MenuItem>
      ))}
    </TextField>
    {betLevels.isError && <RetryAlert onRetry={betLevels.refetch}>Unable to load bet levels.</RetryAlert>}
    {betLevels.isSuccess && !betLevels.data.length && (
      <Alert severity='warning'>No bet levels are available for this game.</Alert>
    )}
  </>
);

export default GgaBetLevelField;
